

// // src/components/Excusas/ExcusasEstudiante.jsx

// import React, { useState, useEffect } from "react";
// import { useAuth } from "../../context/AuthContext";
// import axios from "../../api/axiosAuth";



// const API_BASE = "http://localhost:5001/api/excusas";

// export default function ExcusasEstudiante() {
//   const { token, user } = useAuth(); // ← NECESARIO para tenant y sede

//   const [form, setForm] = useState({
//     fecha_inicio: "",
//     fecha_fin: "",
//     motivo: "",
//     comentario_estudiante: "",
//     toda_jornada: false,
//     hora_inicio: "",
//     hora_fin: "",
//     archivo: null,
//   });

//   const [loading, setLoading] = useState(false);
//   const [misExcusas, setMisExcusas] = useState([]);
//   const [filtros, setFiltros] = useState({
//     estado: "pendiente",
//     periodo: "",
//     anio: "",
//   });

//   const [periodosOpts, setPeriodosOpts] = useState([]);
//   const [aniosOpts, setAniosOpts] = useState([]);

//   /* ============================================================
//       🔹 Cargar filtros MULTITENANT
//     ============================================================ */
//   const fetchFiltros = async () => {
//     if (!token || !user) return;
//     try {
//       const res = await axios.get(`${API_BASE}/filters`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           tenant_id: user.tenant_id,
//           sede_id: user.sede_id,
//         },
//       });

//       setPeriodosOpts(res.data.periodos || []);
//       setAniosOpts(res.data.anios || []);
//     } catch (err) {
//       console.error("Error cargando filtros:", err);
//     }
//   };

//   /* ============================================================
//       🔹 Cargar mis excusas MULTITENANT
//     ============================================================ */
//   const fetchExcusas = async () => {
//     if (!token || !user) return;

//     setLoading(true);
//     try {
//       const params = new URLSearchParams();

//       if (filtros.estado) params.append("estado", filtros.estado);
//       if (filtros.periodo) params.append("periodo", filtros.periodo);
//       if (filtros.anio) params.append("anio", filtros.anio);

//       params.append("tenant_id", user.tenant_id); // 🔥 MULTITENANT
//       params.append("sede_id", user.sede_id);     // 🔥 MULTITENANT

//       const res = await axios.get(
//         `${API_BASE}/mis-excusas?${params.toString()}`,
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       const data = (res.data || []).map((e) => ({
//         ...e,
//         horas:
//           e.horas && typeof e.horas === "string"
//             ? JSON.parse(e.horas)
//             : e.horas,
//       }));

//       setMisExcusas(data);
//     } catch (err) {
//       console.error("Error cargando excusas:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Inicializar datos
//   useEffect(() => {
//     if (token && user) {
//       fetchFiltros();
//       fetchExcusas();
//     }
//   }, [token, user]);

//   /* ============================================================
//       🔹 Manejo de formulario
//     ============================================================ */
//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm({ ...form, [name]: type === "checkbox" ? checked : value });
//   };

//   const handleFileChange = (e) =>
//     setForm({ ...form, archivo: e.target.files[0] });

//   const handleFiltroChange = (e) => {
//     const { name, value } = e.target;
//     setFiltros({ ...filtros, [name]: value });
//   };

//   /* ============================================================
//       🔹 Enviar excusa MULTITENANT
//     ============================================================ */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!form.fecha_inicio || !form.fecha_fin || !form.motivo)
//       return alert("Complete todos los campos obligatorios");

//     if (!form.toda_jornada) {
//       if (!form.hora_inicio || !form.hora_fin)
//         return alert("Debe seleccionar un rango de horas");
//       if (form.hora_inicio >= form.hora_fin)
//         return alert("La hora de inicio debe ser menor que la hora de fin");
//     }

//     setLoading(true);

//     try {
//       const data = new FormData();

//       data.append("fecha_inicio", form.fecha_inicio);
//       data.append("fecha_fin", form.fecha_fin);
//       data.append("motivo", form.motivo);
//       data.append("comentario_estudiante", form.comentario_estudiante);
//       data.append("toda_jornada", form.toda_jornada ? 1 : 0);

//       if (!form.toda_jornada) {
//         const horas = [
//           {
//             hora_inicio: form.hora_inicio,
//             hora_fin: form.hora_fin,
//           },
//         ];
//         data.append("horas", JSON.stringify(horas));
//       }

//       if (form.archivo) data.append("archivo", form.archivo);

//       /* 🔥 MULTITENANT 🔥 */
//       data.append("tenant_id", user.tenant_id);
//       data.append("sede_id", user.sede_id);

//       const res = await axios.post(`${API_BASE}`, data, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       alert(res.data.message);

//       setForm({
//         fecha_inicio: "",
//         fecha_fin: "",
//         motivo: "",
//         comentario_estudiante: "",
//         toda_jornada: false,
//         hora_inicio: "",
//         hora_fin: "",
//         archivo: null,
//       });

//       fetchExcusas();
//     } catch (err) {
//       console.error("Error al enviar excusa:", err);
//       alert(err.response?.data?.message || "Error al enviar excusa");
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ============================================================
//       🔹 Render
//     ============================================================ */
//   const formatDate = (d) =>
//     d ? new Date(d).toLocaleDateString() : "-";

//   return (
//     <div className="excusa-container">
//       <form className="excusa-form" onSubmit={handleSubmit}>
//         <h2>Enviar Excusa</h2>

//         <input
//           type="date"
//           name="fecha_inicio"
//           value={form.fecha_inicio}
//           onChange={handleChange}
//           required
//         />
//         <input
//           type="date"
//           name="fecha_fin"
//           value={form.fecha_fin}
//           onChange={handleChange}
//           required
//         />

//         <textarea
//           name="motivo"
//           value={form.motivo}
//           onChange={handleChange}
//           placeholder="Motivo"
//           required
//         />
//         <textarea
//           name="comentario_estudiante"
//           value={form.comentario_estudiante}
//           onChange={handleChange}
//           placeholder="Comentario opcional"
//         />

//         <label>
//           <input
//             type="checkbox"
//             name="toda_jornada"
//             checked={form.toda_jornada}
//             onChange={handleChange}
//           />
//           Toda la jornada
//         </label>

//         {!form.toda_jornada && (
//           <div className="horas-selector">
//             <h4>Seleccionar rango de horas</h4>

//             <label>Desde:</label>
//             <input
//               type="time"
//               name="hora_inicio"
//               value={form.hora_inicio}
//               onChange={handleChange}
//               required
//             />

//             <label>Hasta:</label>
//             <input
//               type="time"
//               name="hora_fin"
//               value={form.hora_fin}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         )}

//         <input type="file" onChange={handleFileChange} />

//         <button className="btn-primary" disabled={loading}>
//           {loading ? "Enviando..." : "Enviar"}
//         </button>
//       </form>

//       {/* Filtros */}
//       <div className="filtros-excusas">
//         <h3>Filtrar Mis Excusas</h3>

//         <select
//           name="estado"
//           value={filtros.estado}
//           onChange={handleFiltroChange}
//         >
//           <option value="">— Todos —</option>
//           <option value="pendiente">Pendiente</option>
//           <option value="aprobada">Aprobada</option>
//           <option value="rechazada">Rechazada</option>
//         </select>

//         <select
//           name="periodo"
//           value={filtros.periodo}
//           onChange={handleFiltroChange}
//         >
//           <option value="">— Periodos —</option>
//           {periodosOpts.map((p) => (
//             <option key={`p-${p.id}`} value={p.id}>
//               {p.nombre}
//             </option>
//           ))}
//         </select>

//         <select
//           name="anio"
//           value={filtros.anio}
//           onChange={handleFiltroChange}
//         >
//           <option value="">— Años —</option>
//           {aniosOpts.map((a) => (
//             <option key={`a-${a.id}`} value={a.id}>
//               {a.anio}
//             </option>
//           ))}
//         </select>

//         <button onClick={fetchExcusas}>🔍 Aplicar</button>
//         <button
//           onClick={() => {
//             setFiltros({
//               estado: "pendiente",
//               periodo: "",
//               anio: "",
//             });
//             fetchExcusas();
//           }}
//         >
//           ♻️ Reset
//         </button>
//       </div>

//       {/* Mis excusas */}
//       <div className="mis-excusas">
//         <h3>Mis Excusas</h3>

//         {loading && <p>Cargando...</p>}

//         {!loading && misExcusas.length === 0 && (
//           <p>No hay excusas enviadas</p>
//         )}

//         {!loading && misExcusas.length > 0 && (
//           <table className="tabla-excusas">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Motivo</th>
//                 <th>Fechas</th>
//                 <th>Horas</th>
//                 <th>Estado</th>
//                 <th>Respuesta</th>
//                 <th>Archivo</th>
//               </tr>
//             </thead>

//             <tbody>
//               {misExcusas.map((e, i) => (
//                 <tr key={e.id || `me-${i}`}>
//                   <td>{i + 1}</td>
//                   <td>{e.motivo}</td>
//                   <td>
//                     {formatDate(e.fecha_inicio)} →{" "}
//                     {formatDate(e.fecha_fin)}
//                   </td>

//                   <td>
//                     {e.toda_jornada
//                       ? "Toda la jornada"
//                       : Array.isArray(e.horas)
//                       ? e.horas
//                           .map(
//                             (h) =>
//                               `${(h.hora_inicio || "").slice(
//                                 0,
//                                 5
//                               )} → ${(h.hora_fin || "").slice(0, 5)}`
//                           )
//                           .join(", ")
//                       : "-"}
//                   </td>

//                   <td>{e.estado}</td>
//                   <td>{e.respuesta || "-"}</td>

//                   <td>
//                     {e.archivo ? (
//                       <a
//                         href={`http://localhost:5001${e.archivo}`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         Ver
//                       </a>
//                     ) : (
//                       "-"
//                     )}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// }


///

// import React, { useState, useEffect } from "react";
// import { useAuth } from "../../context/AuthContext";
// import axios from "../../api/axiosAuth";
// import "../../style/ExcusasEstudiante.css";

// // const API_BASE = "http://localhost:5001/api/excusas";

// const API_BASE = process.env.REACT_APP_API_BASE 
//   ? `${process.env.REACT_APP_API_BASE}/excusas` 
//   : "http://3.236.217.225:5001/api/excusas";
// export default function ExcusasEstudiante() {
//   const { token, user } = useAuth();

//   const [form, setForm] = useState({
//     fecha_inicio: "",
//     fecha_fin: "",
//     motivo: "",
//     comentario_estudiante: "",
//     toda_jornada: false,
//     hora_inicio: "",
//     hora_fin: "",
//     archivo: null,
//   });

//   const [loading, setLoading] = useState(false);
//   const [misExcusas, setMisExcusas] = useState([]);
//   const [filtros, setFiltros] = useState({
//     estado: "pendiente",
//     periodo: "",
//     anio: "",
//   });

//   const [periodosOpts, setPeriodosOpts] = useState([]);
//   const [aniosOpts, setAniosOpts] = useState([]);

//   const fetchFiltros = async () => {
//     if (!token || !user) return;
//     try {
//       const res = await axios.get(`${API_BASE}/filters`, {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           tenant_id: user.tenant_id,
//           sede_id: user.sede_id,
//         },
//       });
//       setPeriodosOpts(res.data.periodos || []);
//       setAniosOpts(res.data.anios || []);
//     } catch (err) {
//       console.error("Error cargando filtros:", err);
//     }
//   };

//   const fetchExcusas = async () => {
//     if (!token || !user) return;
//     setLoading(true);
//     try {
//       const params = new URLSearchParams();
//       if (filtros.estado) params.append("estado", filtros.estado);
//       if (filtros.periodo) params.append("periodo", filtros.periodo);
//       if (filtros.anio) params.append("anio", filtros.anio);
//       params.append("tenant_id", user.tenant_id);
//       params.append("sede_id", user.sede_id);

//       const res = await axios.get(`${API_BASE}/mis-excusas?${params.toString()}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       const data = (res.data || []).map((e) => ({
//         ...e,
//         horas: e.horas && typeof e.horas === "string" ? JSON.parse(e.horas) : e.horas,
//       }));
//       setMisExcusas(data);
//     } catch (err) {
//       console.error("Error cargando excusas:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (token && user) {
//       fetchFiltros();
//       fetchExcusas();
//     }
//   }, [token, user]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm({ ...form, [name]: type === "checkbox" ? checked : value });
//   };

//   const handleFileChange = (e) => setForm({ ...form, archivo: e.target.files[0] });

//   const handleFiltroChange = (e) => {
//     const { name, value } = e.target;
//     setFiltros({ ...filtros, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.fecha_inicio || !form.fecha_fin || !form.motivo) return alert("Campos obligatorios faltantes");

//     setLoading(true);
//     try {
//       const data = new FormData();
//       data.append("fecha_inicio", form.fecha_inicio);
//       data.append("fecha_fin", form.fecha_fin);
//       data.append("motivo", form.motivo);
//       data.append("comentario_estudiante", form.comentario_estudiante);
//       data.append("toda_jornada", form.toda_jornada ? 1 : 0);
//       data.append("tenant_id", user.tenant_id);
//       data.append("sede_id", user.sede_id);

//       if (!form.toda_jornada) {
//         const horas = [{ hora_inicio: form.hora_inicio, hora_fin: form.hora_fin }];
//         data.append("horas", JSON.stringify(horas));
//       }
//       if (form.archivo) data.append("archivo", form.archivo);

//       const res = await axios.post(API_BASE, data, {
//         headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
//       });

//       alert(res.data.message);
//       setForm({
//         fecha_inicio: "", fecha_fin: "", motivo: "", comentario_estudiante: "",
//         toda_jornada: false, hora_inicio: "", hora_fin: "", archivo: null,
//       });
//       fetchExcusas();
//     } catch (err) {
//       alert(err.response?.data?.message || "Error al enviar");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (d) => (d ? new Date(d).toLocaleDateString() : "-");

//   return (
//     <div className="excusa-container">
//       <form className="excusa-form" onSubmit={handleSubmit}>
//         <h2>Enviar Excusa</h2>
//         <div className="form-group-row">
//           <input type="date" name="fecha_inicio" value={form.fecha_inicio} onChange={handleChange} required />
//           <input type="date" name="fecha_fin" value={form.fecha_fin} onChange={handleChange} required />
//         </div>

//         <textarea name="motivo" value={form.motivo} onChange={handleChange} placeholder="Motivo de la excusa" required />
//         <textarea name="comentario_estudiante" value={form.comentario_estudiante} onChange={handleChange} placeholder="Comentarios adicionales" />

//         <label className="checkbox-label">
//           <input type="checkbox" name="toda_jornada" checked={form.toda_jornada} onChange={handleChange} />
//           Toda la jornada laboral/escolar
//         </label>

//         {!form.toda_jornada && (
//           <div className="horas-selector">
//             <h4>Rango de horas:</h4>
//             <div className="input-group">
//               <label>Desde:</label>
//               <input type="time" name="hora_inicio" value={form.hora_inicio} onChange={handleChange} required />
//             </div>
//             <div className="input-group">
//               <label>Hasta:</label>
//               <input type="time" name="hora_fin" value={form.hora_fin} onChange={handleChange} required />
//             </div>
//           </div>
//         )}

//         <div className="file-input-wrapper">
//           <label>Soportes (PDF/Imagen):</label>
//           <input type="file" onChange={handleFileChange} accept="image/*,.pdf" />
//         </div>

//         <button className="btn-primary" disabled={loading}>
//           {loading ? "Procesando..." : "🚀 Enviar Excusa"}
//         </button>
//       </form>

//       <div className="filtros-excusas">
//         <h3>🔍 Filtrar Historial</h3>
//         <div className="filtros-grid">
//           <select name="estado" value={filtros.estado} onChange={handleFiltroChange}>
//             <option value="">Todos los estados</option>
//             <option value="pendiente">Pendientes</option>
//             <option value="aprobada">Aprobadas</option>
//             <option value="rechazada">Rechazadas</option>
//           </select>

//           <select name="periodo" value={filtros.periodo} onChange={handleFiltroChange}>
//             <option value="">Todos los periodos</option>
//             {periodosOpts.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}
//           </select>

//           <select name="anio" value={filtros.anio} onChange={handleFiltroChange}>
//             <option value="">Todos los años</option>
//             {aniosOpts.map((a) => <option key={a.id} value={a.id}>{a.anio}</option>)}
//           </select>
          
//           <button className="btn-search" onClick={fetchExcusas}>Buscar</button>
//         </div>
//       </div>

//       <div className="mis-excusas">
//         <h3>Historial de Excusas</h3>
//         <div className="table-responsive">
//           <table className="tabla-excusas">
//             <thead>
//               <tr>
//                 <th>Motivo</th>
//                 <th>Fechas</th>
//                 <th>Horas</th>
//                 <th>Estado</th>
//                 <th>Respuesta</th>
//                 <th>Soporte</th>
//               </tr>
//             </thead>
//             <tbody>
//               {misExcusas.map((e) => (
//                 <tr key={e.id}>
//                   <td data-label="Motivo">{e.motivo}</td>
//                   <td data-label="Fechas">{formatDate(e.fecha_inicio)} - {formatDate(e.fecha_fin)}</td>
//                   <td data-label="Horas">
//                     {e.toda_jornada ? "Completa" : e.horas?.map(h => `${h.hora_inicio.slice(0,5)} - ${h.hora_fin.slice(0,5)}`).join(", ")}
//                   </td>
//                   <td data-label="Estado">
//                     <span className={`status-badge ${e.estado}`}>{e.estado}</span>
//                   </td>
//                   <td data-label="Respuesta">{e.respuesta || "Sin respuesta"}</td>
//                   <td data-label="Soporte">
//                     {e.archivo ? (
//                       <a href={`http://localhost:5001${e.archivo}`} target="_blank" rel="noreferrer" className="btn-view">Ver</a>
//                     ) : "-"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import axios from "../../api/axiosAuth";
import "../../style/ExcusasEstudiante.css";
// 1. IMPORTAMOS LAS CONSTANTES CENTRALIZADAS
import { API, UPLOADS_URL } from "../config"; 

export default function ExcusasEstudiante() {
  const { token, user } = useAuth();

  const [form, setForm] = useState({
    fecha_inicio: "",
    fecha_fin: "",
    motivo: "",
    comentario_estudiante: "",
    toda_jornada: false,
    hora_inicio: "",
    hora_fin: "",
    archivo: null,
  });

  const [loading, setLoading] = useState(false);
  const [misExcusas, setMisExcusas] = useState([]);
  const [filtros, setFiltros] = useState({
    estado: "pendiente",
    periodo: "",
    anio: "",
  });

  const [periodosOpts, setPeriodosOpts] = useState([]);
  const [aniosOpts, setAniosOpts] = useState([]);

  /* ==============================
      📥 CARGAR FILTROS
  ============================== */
  const fetchFiltros = async () => {
    if (!token || !user) return;
    try {
      // 2. CORREGIDO: Ruta relativa usando axiosAuth
      const res = await axios.get("/excusas/filters", {
        params: {
          tenant_id: user.tenant_id,
          sede_id: user.sede_id,
        },
      });
      setPeriodosOpts(res.data.periodos || []);
      setAniosOpts(res.data.anios || []);
    } catch (err) {
      console.error("Error cargando filtros:", err);
    }
  };

  /* ==============================
      📥 OBTENER HISTORIAL
  ============================== */
  const fetchExcusas = async () => {
    if (!token || !user) return;
    setLoading(true);
    try {
      const res = await axios.get("/excusas/mis-excusas", {
        params: {
          estado: filtros.estado,
          periodo: filtros.periodo,
          anio: filtros.anio,
          tenant_id: user.tenant_id,
          sede_id: user.sede_id,
        },
      });

      const data = (res.data || []).map((e) => ({
        ...e,
        horas: e.horas && typeof e.horas === "string" ? JSON.parse(e.horas) : e.horas,
      }));
      setMisExcusas(data);
    } catch (err) {
      console.error("Error cargando excusas:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token && user) {
      fetchFiltros();
      fetchExcusas();
    }
  }, [token, user]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleFileChange = (e) => setForm({ ...form, archivo: e.target.files[0] });

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros({ ...filtros, [name]: value });
  };

  /* ==============================
      📤 ENVIAR EXCUSA
  ============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.fecha_inicio || !form.fecha_fin || !form.motivo) return alert("Campos obligatorios faltantes");

    setLoading(true);
    try {
      const data = new FormData();
      data.append("fecha_inicio", form.fecha_inicio);
      data.append("fecha_fin", form.fecha_fin);
      data.append("motivo", form.motivo);
      data.append("comentario_estudiante", form.comentario_estudiante);
      data.append("toda_jornada", form.toda_jornada ? 1 : 0);
      data.append("tenant_id", user.tenant_id);
      data.append("sede_id", user.sede_id);

      if (!form.toda_jornada) {
        const horas = [{ hora_inicio: form.hora_inicio, hora_fin: form.hora_fin }];
        data.append("horas", JSON.stringify(horas));
      }
      if (form.archivo) data.append("archivo", form.archivo);

      // 3. CORREGIDO: Ruta relativa y eliminamos headers manuales (axiosAuth los pone)
      const res = await axios.post("/excusas", data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert(res.data.message || "✅ Excusa enviada correctamente");
      setForm({
        fecha_inicio: "", fecha_fin: "", motivo: "", comentario_estudiante: "",
        toda_jornada: false, hora_inicio: "", hora_fin: "", archivo: null,
      });
      fetchExcusas();
    } catch (err) {
      alert(err.response?.data?.message || "Error al enviar");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => (d ? new Date(d).toLocaleDateString() : "-");

  return (
    <div className="excusa-container">
      <form className="excusa-form" onSubmit={handleSubmit}>
        <h2>Enviar Excusa</h2>
        <div className="form-group-row">
          <input type="date" name="fecha_inicio" value={form.fecha_inicio} onChange={handleChange} required />
          <input type="date" name="fecha_fin" value={form.fecha_fin} onChange={handleChange} required />
        </div>

        <textarea name="motivo" value={form.motivo} onChange={handleChange} placeholder="Motivo de la excusa" required />
        <textarea name="comentario_estudiante" value={form.comentario_estudiante} onChange={handleChange} placeholder="Comentarios adicionales" />

        <label className="checkbox-label">
          <input type="checkbox" name="toda_jornada" checked={form.toda_jornada} onChange={handleChange} />
          Toda la jornada escolar
        </label>

        {!form.toda_jornada && (
          <div className="horas-selector">
            <h4>Rango de horas:</h4>
            <div className="input-group">
              <label>Desde:</label>
              <input type="time" name="hora_inicio" value={form.hora_inicio} onChange={handleChange} required />
            </div>
            <div className="input-group">
              <label>Hasta:</label>
              <input type="time" name="hora_fin" value={form.hora_fin} onChange={handleChange} required />
            </div>
          </div>
        )}

        <div className="file-input-wrapper">
          <label>Soportes (PDF/Imagen):</label>
          <input type="file" onChange={handleFileChange} accept="image/*,.pdf" />
        </div>

        <button className="btn-primary" disabled={loading}>
          {loading ? "Procesando..." : "🚀 Enviar Excusa"}
        </button>
      </form>

      <div className="filtros-excusas">
        <h3>🔍 Filtrar Historial</h3>
        <div className="filtros-grid">
          <select name="estado" value={filtros.estado} onChange={handleFiltroChange}>
            <option value="">Todos los estados</option>
            <option value="pendiente">Pendientes</option>
            <option value="aprobada">Aprobadas</option>
            <option value="rechazada">Rechazadas</option>
          </select>

          <select name="periodo" value={filtros.periodo} onChange={handleFiltroChange}>
            <option value="">Todos los periodos</option>
            {periodosOpts.map((p) => <option key={p.id} value={p.id}>{p.nombre}</option>)}
          </select>

          <select name="anio" value={filtros.anio} onChange={handleFiltroChange}>
            <option value="">Todos los años</option>
            {aniosOpts.map((a) => <option key={a.id} value={a.id}>{a.anio}</option>)}
          </select>
          
          <button className="btn-search" onClick={fetchExcusas}>Buscar</button>
        </div>
      </div>

      <div className="mis-excusas">
        <h3>Historial de Excusas</h3>
        <div className="table-responsive">
          <table className="tabla-excusas">
            <thead>
              <tr>
                <th>Motivo</th>
                <th>Fechas</th>
                <th>Horas</th>
                <th>Estado</th>
                <th>Respuesta</th>
                <th>Soporte</th>
              </tr>
            </thead>
            <tbody>
              {misExcusas.map((e) => (
                <tr key={e.id}>
                  <td data-label="Motivo">{e.motivo}</td>
                  <td data-label="Fechas">{formatDate(e.fecha_inicio)} - {formatDate(e.fecha_fin)}</td>
                  <td data-label="Horas">
                    {e.toda_jornada ? "Completa" : e.horas?.map(h => `${h.hora_inicio.slice(0,5)} - ${h.hora_fin.slice(0,5)}`).join(", ")}
                  </td>
                  <td data-label="Estado">
                    <span className={`status-badge ${e.estado}`}>{e.estado}</span>
                  </td>
                  <td data-label="Respuesta">{e.respuesta || "Sin respuesta"}</td>
                  <td data-label="Soporte">
                    {/* 4. CORREGIDO: Usamos UPLOADS_URL para que no falle en producción */}
                    {e.archivo ? (
                      <a href={`${UPLOADS_URL}${e.archivo}`} target="_blank" rel="noreferrer" className="btn-view">Ver</a>
                    ) : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}